<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid manage-suppliers">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Suppliers</h4>
            <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
              <router-link
                :to="{ name: 'ManageSuppliers' }"
                class="d-inline"
                style="font-weight: normal;"
              >
                Supplier List
              </router-link>
              <p class="d-inline pl-1 pr-1">/</p>
              <router-link
                :to="{}"
                class="d-inline"
                style="font-weight: normal;"
              >
                Supplier
              </router-link>
            </div>
            <addSuppliersForm></addSuppliersForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import AddSuppliersForm from "./AddSuppliersForm.vue";
export default {
  name: "AddSuppliers",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    addSuppliersForm: AddSuppliersForm,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "addSupplier",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.manage-suppliers {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
